
import {
  computed,
  defineComponent,
} from 'vue';
import { useMainStore } from '@/store/mainStore';
import AppBottomPopUp from '@/components/BottomPopUp/AppBottomPopUp.vue';
import DriveSharedBar from '@/modules/drive/components/DriveSharedBar.vue';
import { useDriveStore } from '@/modules/drive/store/driveStore';

export default defineComponent({
  components: {
    AppBottomPopUp,
    DriveSharedBar,
  },
  setup() {
    const mainStore = useMainStore();
    const driveStore = useDriveStore();

    const sharedTo = computed(() => {
      if (driveStore.currentCase.share) {
        return driveStore.currentCase.share.sharedAccounts.length + driveStore.currentCase.share.sharedGroups.length;
      }
      return 0;
    });

    function hidePopUp() {
      mainStore.BottomPopUpType = null;
    }

    return {
      mainStore,
      sharedTo,
      hidePopUp,
    };
  },
});
